<template>
  <div>
    <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="800px" lazy>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-tabs
        v-model="activeTab"
        color="primary"
        dark
        show-arrows
      >
        <v-tabs-slider color="white"></v-tabs-slider>

        <v-tab href="#tab-1">
          General Info
        </v-tab>

        <v-tab v-if="isEdit" href="#tab-2">
          Committees
        </v-tab>

        <v-tab v-if="isEdit" href="#tab-3">
          Titles
        </v-tab>

        <v-tab v-if="isEdit" href="#tab-4">
          Awards
        </v-tab>

        <v-tab v-if="isEdit" href="#tab-5">
          Evals
        </v-tab>

        <v-tab-item :value="'tab-1'">
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md8 order-xs2 order-md1>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs10 md5>
                          <v-text-field
                            v-model="editedItem.firstName"
                            @keyup.enter="save"
                            label="First Name"
                            ref="focusName"
                            v-validate="'required'"
                            :error-messages="errors.collect('first name')"
                            data-vv-name="first name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2 md1>
                          <v-text-field
                            v-model="editedItem.middle"
                            @keyup.enter="save"
                            label="M"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="editedItem.lastName"
                            @keyup.enter="save"
                            label="Last Name"
                            v-validate="'required'"
                            :error-messages="errors.collect('last name')"
                            data-vv-name="last name"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.address1"
                        @keyup.enter="save"
                        label="Address"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs10 md5>
                          <v-text-field
                            v-model="editedItem.city"
                            @keyup.enter="save"
                            label="City"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2 md2>
                          <v-text-field
                            v-model="editedItem.state"
                            @keyup.enter="save"
                            label="ST"
                            mask="AA"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md5>
                          <v-text-field
                            v-model="editedItem.zip"
                            @keyup.enter="save"
                            label="Zipcode"
                            mask="#####"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 md4 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                    <v-flex xs12 text-xs-center>
                      <v-layout wrap>
                        <v-flex xs12>
                          <croppa
                            v-model="croppa"
                            :initial-image="initialImage"
                            :placeholder-font-size="14"
                            :prevent-white-space="true"
                            :disable-drag-and-drop="false"
                            :width="180"
                            :height="180"
                            :zoom-speed="7"
                          >
                          </croppa>
                        </v-flex>
                        <v-flex xs12>
                          <v-btn
                            flat
                            icon
                            color="primary"
                            small
                            @click="croppa.rotate(-1)"
                          >
                            <v-icon>rotate_left</v-icon>
                          </v-btn>
                          <v-btn
                            flat
                            icon
                            color="primary"
                            small
                            @click="croppa.rotate()"
                          >
                            <v-icon>rotate_right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 md8>
                    <v-text-field
                      v-model="editedItem.email"
                      @keyup.enter="save"
                      label="Email Address"
                      prepend-icon="email"
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email')"
                      data-vv-name="email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="editedItem.password"
                      id="password"
                      @keyup.enter="save"
                      label="Password"
                      prepend-icon="lock"
                      :append-icon="showpassword ? 'visibility_off' : 'visibility'"
                      :type="showpassword ? 'text' : 'password'"
                      @click:append="() => (showpassword = !showpassword)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      :items="mobileTypes"
                      v-model="editedItem.MobileTypeId"
                      menu-props="auto"
                      label="Mobile Type"
                      hide-details
                      prepend-icon="cellphone-cog"
                      @keyup.enter="save"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.cellPhone"
                      @keyup.enter="save"
                      label="Mobile"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.homePhone"
                      @:keyup.enter="save"
                      label="Home"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.workPhone"
                      @keyup.enter="save"
                      label="Work"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="business"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4>
                    <v-text-field
                      v-model="editedItem.startDate"
                      @keyup.enter="save"
                      label="Start Year"
                      mask="####"
                      prepend-icon="event"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu1"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="formattedDate"
                        label="Birth Date"
                        prepend-icon="cake"
                        @change="editedItem.birthDate = saveDate(formattedDate)"
                      ></v-text-field>
                      <v-date-picker
                        v-model="editedItem.birthDate"
                        no-title
                        @input="menu1 = false"
                        @change="formattedDate = formatDate(editedItem.birthDate)"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6 md4>
                    <v-select
                      :items="handBooks"
                      v-model="editedItem.handBook"
                      menu-props="auto"
                      label="Handbook"
                      hide-details
                      prepend-icon="book"
                      @keyup.enter="save"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 md4>
                    <v-select
                      :items="statuses"
                      v-model="editedItem.status"
                      menu-props="auto"
                      label="Status"
                      hide-details
                      prepend-icon="traffic"
                      @keyup.enter="save"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="editedItem.iceName"
                      @:keyup.enter="save"
                      label="Emerg Contact"
                      prepend-icon="mdi-medical-bag"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="editedItem.icePhone"
                      @:keyup.enter="save"
                      label="Emerg Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="editedItem.notes"
                      label="Notes"
                      prepend-icon="notes"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-btn
                v-if="editedItem.TitleId === 17"
                color="blue darken-1"
                flat
                @click.native="printApp"
              >Print</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                v-if="saving"
                @click.stop="show=false"
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                transition="fade-transition"
                v-if="!saving"
                flat
                @click.stop="show=false"
              >Close</v-btn>
              <v-btn
                color="blue darken-1"
                dark
                transition="fade-transition"
                v-if="saving"
                @click.native="save"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-2'">
          <v-card>
            <v-card-text>
              <v-container
                fluid
                grid-list-lg
              >
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="yearSelect"
                      v-model="currentYear"
                      label="Current Year"
                      hide-details
                      prepend-icon="event"
                      outline
                      @change="selectCommittees"
                    ></v-autocomplete>
                  </v-flex>

                  <div class="scroll-here">
                    <v-flex v-for="currentCommittee in currentCommittees" :key="currentCommittee.id" xs12>
                      <v-card class="elevation-4">
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs6 md8>
                              {{ currentCommittee.name }}
                            </v-flex>
                            <v-flex xs4 md3>
                              <strong>{{ currentCommittee.title }}</strong>
                            </v-flex>
                            <v-flex xs2 md1>
                              <v-avatar
                                color="red lighten-4"
                                class="mr-2 mt-2"
                                size="30"
                                style="cursor: pointer;"
                                @click="deleteCommittee(currentCommittee.id)"
                              >
                                <v-icon small>delete</v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <v-flex xs12>
                    <v-card class="elevation-4">
                      <v-card-title>
                        Add Committee
                      </v-card-title>
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md7>
                            <v-autocomplete
                              :items="committeeList"
                              v-model="editedCommittee.committeeId"
                              label="Committee"
                              hide-details
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm4 md3>
                            <v-autocomplete
                              :items="levelList"
                              v-model="editedCommittee.title"
                              label="Level"
                              hide-details
                              @keyup.enter="save"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md2>
                            <v-btn
                              color="blue darken-1"
                              dark
                              transition="fade-transition"
                              @click.native="saveCommittee"
                            >Save</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click.stop="show=false"
              >Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-3'">
          <v-card>
            <v-card-text>
              <v-container
                fluid
                grid-list-lg
              >
                <v-layout row wrap>
                  <div class="scroll-here">
                  <v-flex v-for="userTitle in userTitles" :key="userTitle.id" xs12>
                    <v-card class="elevation-4">
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex xs4 md3>
                            {{ userTitle.date | formatDate }}
                          </v-flex>
                          <v-flex xs6 md8>
                            <strong>{{ userTitle.name }}</strong>
                          </v-flex>
                          <v-flex xs2 md1>
                            <v-avatar
                              color="red lighten-4"
                              class="mr-2 mt-2"
                              size="30"
                              style="cursor: pointer;"
                              @click="deleteTitle(userTitle.id)"
                            >
                              <v-icon small>delete</v-icon>
                            </v-avatar>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  </div>
                  <v-flex xs12>
                    <v-card class="elevation-4">
                      <v-card-title>
                        Add Title
                      </v-card-title>
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex xs12 sm4 md3>
                            <v-menu
                              :close-on-content-click="false"
                              v-model="menu2"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <v-text-field
                                slot="activator"
                                v-model="formattedTitleDate"
                                label="Start Date"
                                readonly
                              ></v-text-field>
                              <v-date-picker
                                v-model="editedTitle.date"
                                no-title
                                @input="menu2 = false"
                                @change="formattedTitleDate = formatDate(editedTitle.date)"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm6 md7>
                            <v-select
                              :items="titleList"
                              v-model="editedTitle.TitleId"
                              label="Title"
                              hide-details
                              @keyup.enter="save"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 md2>
                            <v-btn
                              color="blue darken-1"
                              dark
                              transition="fade-transition"
                              @click.native="saveTitle"
                            >Save</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click.stop="show=false"
              >Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-4'">
          <v-card>
            <v-card-text>
              <v-container
                fluid
                grid-list-lg
              >
                <v-layout row wrap>
                  <div class="scroll-here">
                  <v-flex v-for="userAward in userAwards" :key="userAward.id" xs12>
                    <v-card class="elevation-4">
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex xs4 md3>
                            {{ userAward.date }}
                          </v-flex>
                          <v-flex xs6 md8>
                            <strong>{{ userAward.award }}</strong>
                          </v-flex>
                          <v-flex xs2 md1>
                            <v-avatar
                              color="red lighten-4"
                              class="mr-2 mt-2"
                              size="30"
                              style="cursor: pointer;"
                              @click="deleteAward(userAward.id)"
                            >
                              <v-icon small>delete</v-icon>
                            </v-avatar>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  </div>
                  <v-flex xs12>
                    <v-card class="elevation-4">
                      <v-card-title>
                        Add Award
                      </v-card-title>
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex xs12 sm4 md3>
                            <v-text-field
                              v-model="editedAward.date"
                              @keyup.enter="save"
                              label="Year"
                              mask="####"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md7>
                            <v-text-field
                              v-model="editedAward.award"
                              @keyup.enter="save"
                              label="Award"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md2>
                            <v-btn
                              color="blue darken-1"
                              dark
                              transition="fade-transition"
                              @click.native="saveAward"
                            >Save</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click.stop="show=false"
              >Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-5'">
          <EvalForm
            :newEvals="newEvals"
            :oldEvals="oldEvals"
          />
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import 'vue-croppa/dist/vue-croppa.css'
import moment from 'moment'

export default {
  props: ['visible', 'item', 'isEdit', 'isOpen'],

  components: {
    EvalForm: () => import('./EvalList')
  },

  $_veeValidate: {
    validator: 'new'
  },

  data () {
    return {
      menu1: false,
      menu2: false,
      formattedDate: '',
      formattedTitleDate: '',
      editedCommittee: {
        id: '',
        title: '',
        userId: 0,
        committeeId: 0
      },
      defaultCommittee: {
        id: '',
        title: '',
        userId: 0,
        committeeId: 0
      },
      loadCommittee: {
        text: '',
        value: 0
      },
      loadDefaultCommittee: {
        text: '',
        value: 0
      },
      editedTitle: {
        id: '',
        date: '',
        TitleId: '',
        UserId: '',
        name: ''
      },
      defaultTitle: {
        id: '',
        date: '',
        TitleId: '',
        UserId: '',
        name: ''
      },
      editedAward: {
        id: '',
        date: '',
        award: '',
        UserId: ''
      },
      defaultAward: {
        id: '',
        date: '',
        award: '',
        UserId: ''
      },
      firstTime: true,
      saving: false,
      showSaving: this.isOpen,
      showpassword: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      activeTab: '',
      statuses: [
        { text: 'Inactive', value: 'inactive' },
        { text: 'Active', value: 'active' }
      ],
      handBooks: [
        { text: 'No', value: false },
        { text: 'Yes', value: true }
      ],
      mobileTypes: [],
      yearSelect: [],
      titleList: [],
      committeeList: [],
      levelList: [],
      controlList: [],
      newEvals: {},
      oldEvals: {},
      croppa: {},
      initialImage: null,
      editedItem: this.item,
      userDetail: {},
      defaultItem: {
        id: 0,
        firstName: '',
        middle: '',
        lastName: '',
        email: '',
        password: '',
        image: '',
        picture: '',
        imageFile: '',
        dataUrl: '',
        address1: '',
        city: '',
        state: '',
        zip: '',
        homePhone: '',
        cellPhone: '',
        workPhone: '',
        status: 'inactive',
        startDate: '',
        birthDate: '',
        handBook: 0,
        notes: '',
        Title: {
          name: ''
        }
      },
      userCommittees: {},
      userTest: {},
      currentCommittees: {},
      currentCommitteeList: {},
      userTitles: {},
      userAwards: {},
      currentYear: 0
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear

    for (var i = 2013; i <= this.currentYear; i++) {
      this.yearSelect.push(i)
    }

    this.getMobileTypes()
  },

  mounted () {
    this.$validator.localize('en', this.dictionary)
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.activeTab = 'tab-1'
          this.$emit('close', 'the test')
          // Object.assign(this.$data, this.$options.data())
        }
      }
    }
  },

  watch: {
    activeTab (val) {
      if (this.activeTab === 'tab-1') {
        this.$nextTick(this.$refs.focusName.focus)
      }

      if (this.activeTab === 'tab-2') {
        this.getLevelItems()
        this.getUserCommittees()
        this.getCommitteeItems()
        console.log('no 2')
      }

      if (this.activeTab === 'tab-3') {
        this.getTitleItems()
        this.getNewCommittees()
        this.getUserTitles(this.editedItem)
        console.log('no 3')
      }

      if (this.activeTab === 'tab-4') {
        this.getAwards(this.editedItem)
        console.log('no 4')
      }

      if (this.activeTab === 'tab-5') {
        this.getEvals()
        console.log('no 5')
      }
    },
    visible (val) {
      if (val) {
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        // console.log('test')
        if (!this.showSaving) {
          this.saving = true
        }

        this.showSaving = false
      },
      deep: true
    }
  },

  methods: {
    loadItem () {
      this.editedTitle.name = ''
      this.editedTitle.date = ''
      this.editedTitle.TitleId = ''

      if (this.isEdit) {
        this.editedItem = this.item
        // this.getLevelItems()
        this.getUser(this.editedItem)
        // this.getAwards(this.editedItem)
        // this.getUserCommittees()
        // this.getTitleItems()
        // this.getControlItems()
        // this.getCommitteeItems()
        // this.getUserTitles(this.editedItem)
        // console.log(this.editedItem.picture)

        let image = new Image()
        image.setAttribute('crossorigin', 'anonymous')
        image.setAttribute('Access-Control-Allow-Origin', '*')

        if (this.editedItem.image) {
          image.src = this.editedItem.picture
        } else {
          image.src = ''
        }

        this.initialImage = image

        if (this.croppa.refresh) {
          this.croppa.refresh()
        }

        this.formattedDate = moment(this.editedItem.birthDate).format('MM/DD/YYYY')
      } else {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.formattedDate = ''

        let image = new Image()
        image.setAttribute('crossorigin', 'anonymous')
        image.setAttribute('Access-Control-Allow-Origin', '*')
        image.src = ''

        this.initialImage = image

        if (this.croppa.refresh) {
          this.croppa.refresh()
        }
      }
    },

    async getMobileTypes () {
      try {
        const response = await Api().get('get_mobiletypes')
        this.mobileTypes = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    saveDate (date) {
      return Utilities.saveDate(date)
    },

    async getUser (item) {
      console.log('getuser')
      this.userDetail = {}
      this.userCommittees = {}
      this.currentCommittees = {}
      try {
        const response = await Api().get('users/' + item.id)
        this.userDetail = response.data
        console.log('user', this.userDetail)
        this.userDetail.password = ''
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getUserCommittees () {
      try {
        const response = await Api().get('users_committees/' + this.editedItem.id)
        const userCommittees = response.data

        this.userCommittees = userCommittees.map(a => ({
          id: a.id,
          name: a.name,
          title: a.title,
          year: a.year
        }))

        this.currentCommittees = this.userCommittees.filter(obj => {
          return obj.year === this.currentYear
        })
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getNewCommittees () {
      try {
        const response = await Api().get('users_committees/' + this.editedItem.id)
        const userCommittees = response.data

        this.userCommittees = userCommittees.map(a => ({
          id: a.id,
          name: a.name,
          title: a.title,
          year: a.year
        }))

        this.currentCommitteeList = this.userCommittees.filter(obj => {
          return obj.year === this.$store.state.currentYear
        })
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    selectCommittees () {
      this.currentCommittees = this.userCommittees.filter(obj => {
        return obj.year === this.currentYear
      })
    },

    async getTitleItems () {
      try {
        const response = await Api().get('get_titles')
        this.titleList = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getCommitteeItems () {
      try {
        const response = await Api().get('get_committees/' + this.currentYear)
        this.committeeList = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getLevelItems () {
      try {
        const response = await Api().get('get_levels')
        this.levelList = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getControlItems () {
      try {
        const response = await Api().get('get_active_controls')
        this.controlList = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getUserTitles (item) {
      try {
        const response = await Api().get('user_titles/' + item.id)
        this.userTitles = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getEvals () {
      this.newEvals = {}
      this.oldEvals = {}

      try {
        const response = await Api().get('user_evals/' + this.editedItem.id)
        this.newEvals = response.data.newEvals
        this.oldEvals = response.data.oldEvals
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.saving = false
          this.snackbar.message = 'There were errors in the form'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        } else {
          this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)
          this.editedItem.fullName = this.editedItem.firstName + ' ' + this.editedItem.lastName

          if (this.editedItem.id > 0) {
            this.updateItem(this.editedItem)
          } else {
            if (!this.editedItem.birthDate) {
              this.editedItem.birthDate = '1901-01-01'
            }

            this.editedItem.startDate = this.currentYear
            this.editedItem.RoleId = 2
            this.editedItem.TitleId = 4
            this.editedItem.Title.name = 'Wrangler'

            this.addItem(this.editedItem)
          }

          this.$emit('saveUser', this.editedItem)
          this.editedItem = {}
        }
      })
    },

    async addItem (item) {
      try {
        const response = await Api().post('users', item)
        this.editedItem.id = response.data.user.id
        this.editedItem.image = response.data.user.image
        this.editedItem.picture = response.data.user.picture

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        const response = await Api().put('users/' + this.editedItem.id, this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveCommittee () {
      try {
        this.editedCommittee.userId = this.editedItem.id
        const response = await Api().post('user_committees', this.editedCommittee)

        let name = this.committeeList.find(item => item.value === this.editedCommittee.committeeId)
        this.loadCommittee.name = name.text
        this.loadCommittee.title = this.editedCommittee.title
        this.loadCommittee.year = this.currentYear
        this.loadCommittee.id = this.editedCommittee.committeeId

        this.userCommittees.push(this.loadCommittee)
        this.currentCommittees.push(this.loadCommittee)

        setTimeout(() => {
          this.editedCommittee = Object.assign({}, this.defaultCommittee)
          this.loadCommittee = Object.assign({}, this.loadDefaultCommittee)
        }, 300)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteCommittee (committeeId) {
      let r = confirm('Are you sure you want to remove this committee?')

      if (r === true) {
        try {
          const response = await Api().delete('user_committees/' + this.editedItem.id + '/' + committeeId)

          this.userCommittees.splice(this.userCommittees.findIndex(obj => obj.id === committeeId), 1)
          this.currentCommittees.splice(this.currentCommittees.findIndex(obj => obj.id === committeeId), 1)

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async saveTitle () {
      try {
        this.editedTitle.UserId = this.editedItem.id
        this.editedTitle.committees = this.currentCommitteeList

        const response = await Api().post('user_titles', this.editedTitle)

        let name = this.titleList.find(item => item.value === this.editedTitle.TitleId)
        this.editedTitle.name = name.text
        this.editedTitle.id = response.data.title.id

        this.userTitles.push(this.editedTitle)

        setTimeout(() => {
          this.editedTitle = Object.assign({}, this.defaultTitle)
          this.formattedTitleDate = ''
        }, 300)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteTitle (titleId) {
      let r = confirm('Are you sure you want to delete this title?')

      if (r === true) {
        try {
          const response = await Api().delete('user_titles/' + titleId)

          this.userTitles.splice(this.userTitles.findIndex(obj => obj.id === titleId), 1)

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async getAwards (item) {
      try {
        const response = await Api().get('user_awards/' + item.id)
        this.userAwards = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveAward () {
      try {
        this.editedAward.UserId = this.editedItem.id
        const response = await Api().post('user_awards', this.editedAward)

        this.editedAward.id = response.data.award.id

        this.userAwards.push(this.editedAward)

        setTimeout(() => {
          this.editedAward = Object.assign({}, this.defaultAward)
          this.formattedAwardDate = ''
        }, 300)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteAward (awardId) {
      let r = confirm('Are you sure you want to delete this award?')

      if (r === true) {
        try {
          const response = await Api().delete('user_awards/' + awardId)

          this.userAwards.splice(this.userAwards.findIndex(obj => obj.id === awardId), 1)

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async printApp () {
      try {
        await Api().post('get_userpdf/' + this.editedItem.id, this.editedItem).then((response) => {
          window.open(process.env.API_URL + '/attachments/' + this.editedItem.id + 'app.pdf', '_blank')

          // console.log(route)
          console.log(response)
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/UserForm.vue